<mat-dialog-content>
  <img loading="lazy" [src]="imageResource" [alt]="image?.name" class="fill-enlarge" />
</mat-dialog-content>
